<main class="analysis-main">
  <div class="content-container">
    <div class="sub-container">
      <div class="header-container">
        <p class="title">
          {{ 'Past Usage' | translate }}
        </p>
        <p class="sub-title">
          {{ 'View and export your institution’s historic usage' | translate }}
        </p>
      </div>
      <div class="option-picker-container">
        <app-pencil-button
          [dateRangePicker]="dateRangePickerRef"
          class="selection-menu"
          [label]="selectedRange | dateRangePickerSelection"
          [icon]="'expand_more'"
          [iconConfig]="{ type: 'mat-icon' }"
        >
        </app-pencil-button>

        <app-date-range-picker
          #dateRangePickerRef
          (applyButtonClicked)="datepickerRangeChange($event)"
        >
        </app-date-range-picker>
        <app-pencil-button
          class="pencil-button medium white outlined-light cml-8"
          data-name="settings-billing-sessions-download"
          (clickEvent)="downloadCSV()"
          [disabled]="isLoading$ | async"
        >
          <svg-icon
            *ngIf="(isLoading$ | async) === false"
            [icon]="'download'"
            [width]="22"
            [height]="22"
          ></svg-icon>
          <app-pencil-spinner
            *ngIf="isLoading$ | async"
            class="spinner cmr-3 cmt-5"
            [diameter]="18"
            [strokeWidth]="2"
          >
          </app-pencil-spinner>
          <span>{{ 'Download as CSV' | translate }}</span>
        </app-pencil-button>
      </div>
    </div>
  </div>
</main>
